import { createSelector } from 'reselect';
import api from './api';
import { combineReducers } from '../../node_modules/redux';

const stateStaffSelector = (state) => state.staff;

export const selector = createSelector([stateStaffSelector], (staff) => {
  return { ...staff };
});

const STAFF_FETCH_ALL_REQUEST = 'STAFF_FETCH_ALL_REQUEST';
const STAFF_FETCH_ALL_SUCCESS = 'STAFF_FETCH_ALL_SUCCESS';
const STAFF_FETCH_ALL_FAILURE = 'STAFF_FETCH_ALL_FAILURE';

const STAFF__CREATE_REQUEST = 'STAFF__CREATE_REQUEST';
const STAFF__CREATE_SUCCESS = 'STAFF__CREATE_SUCCESS';
const STAFF__CREATE_FAILURE = 'STAFF__CREATE_FAILURE';

const STAFF__UPDATE_REQUEST = 'STAFF__UPDATE_REQUEST';
const STAFF__UPDATE_SUCCESS = 'STAFF__UPDATE_SUCCESS';
const STAFF__UPDATE_FAILURE = 'STAFF__UPDATE_FAILURE';

const STAFF__RESET_NEW_STAFF = 'STAFF__RESET_NEW_STAFF';
const STAFF__UPDATE_NEW_STAFF = 'STAFF__UPDATE_NEW_STAFF';
const STAFF__UPDATE_EDIT_STAFF = 'STAFF__UPDATE_EDIT_STAFF';

const initialState = {
    staff: {},
    newStaff: {
      firstName: '',
      lastName: '',
      title: '',
      email: ''
    }
};

export const actionCreators = {
  resetStaff: () => ({type: STAFF__RESET_NEW_STAFF }),
  updateNewStaff: (staff) => ({type: STAFF__UPDATE_NEW_STAFF, staff}),
  updateEditStaff: (staff) => ({type: STAFF__UPDATE_EDIT_STAFF, staff}),
  getStaff: () =>
    api({
      types: [STAFF_FETCH_ALL_REQUEST, STAFF_FETCH_ALL_SUCCESS, STAFF_FETCH_ALL_FAILURE],
      uri: '/api/staff',
      config: {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
      sendJwtBearer: true,
    }),
  createStaff: (staff) =>
    api({
      types: [STAFF__CREATE_REQUEST, STAFF__CREATE_SUCCESS, STAFF__CREATE_FAILURE],
      uri: '/api/staff',
      config: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(staff),
      },
      payload: staff,
      sendJwtBearer: true,
    }),
  updateStaff: (staff) => 
    api({
      types: [STAFF__UPDATE_REQUEST, STAFF__UPDATE_SUCCESS, STAFF__UPDATE_FAILURE],
      uri: '/api/staff',
      config: {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(staff),
      },
      payload: staff,
      sendJwtBearer: true,
    }),
};

const staff = (state = initialState.staff, action) => {
  switch(action.type) {
    case STAFF__CREATE_SUCCESS:
      return {...state, [action.response]:{...action.payload, id: action.response} };
    case STAFF_FETCH_ALL_SUCCESS:
      return {...state, ...action.response.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})}
    case STAFF__UPDATE_EDIT_STAFF:
      return {...state, ...{[action.staff.id]: action.staff}}
    default: 
      return {...state};
  }
};

const newStaff = (state = initialState.newStaff, action) => {
  switch(action.type) {
    case STAFF__UPDATE_NEW_STAFF:
    return {...state, ...action.staff};
    case STAFF__RESET_NEW_STAFF:
    return {...initialState.newStaff};
    default:
    return {...state};
  }
};

export const reducer = combineReducers({
  staff,
  newStaff
});